import React, { FC, useEffect, useState } from 'react';
import {
  Form,
  Row,
  Col,
  Button,
  Select,
  Divider,
} from 'antd';
import { UserItemData } from '~/Services/UserService.d';
import styles from './Roles.module.less';
import { Utils } from '~/Utils';
import { errorNotification } from '~/Services';
import { RolesResponse } from '~/Services/AdminRolesService'
import { UserItemMeta } from '~/Components/UserItemMeta';
import { UserList } from '~/Components/UserList';
import { useAppDispatch, useAppSelector } from '~/Store/hooks';
import { getRoleModalVisibility } from '~/Store/Organization/selectors';
import { OrganizationActions } from '~/Store/Organization';
import { assignRoleModalName } from './constant';
import { useTranslation } from 'react-i18next';
import { getListUsers } from '~/Store/AdminUser/selectors'
import { AdminUserService } from '~/Services/AdminUsers'

const { Option } = Select;

interface AssignToUserProps {
  role: RolesResponse;
}

export const AssignToUser: FC<AssignToUserProps> = ({ role }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const usersResponse = useAppSelector(getListUsers)
  const users = usersResponse?.results ?? []

  const modalName = `${assignRoleModalName}_${role.name}`;
  const visibility = useAppSelector(getRoleModalVisibility(modalName));
  const [form] = Form.useForm();
  const [assignList, setAssignList] = useState<UserItemData[]>([]);
  const [loading, setLoading] = useState(false);

  const toggleAssignToUsers = () => dispatch(OrganizationActions.setModalState({name: modalName, value: !visibility}));

  useEffect(() => {
    if (visibility) {
      setAssignList([]);
      form.resetFields();
    }
  }, [visibility]);

  const addUsersToAssignList = (values: any) => {
    const { userEmail } = values;
    const user = users.find((i) => i.email === userEmail);
    if (user && !assignList.find((i) => i.email === userEmail)) {
      setAssignList([...assignList, user]);
    }
    form.resetFields();
  };

  const assignRoleToUsers = async () => {
    try {
      setLoading(true)
      const ps: Promise<any>[] = []
      assignList.forEach(i =>
        ps.push(
          AdminUserService.Put.updateRolesUser(i.id, { roleName: role.name }),
        ),
      )
      await Promise.all(ps)
      setLoading(false)
      toggleAssignToUsers()
    } catch (error) {
      errorNotification(error)
      setLoading(false)
    }
  }

  return (
    <>
      {assignList.length > 0 && (
        <>
          <UserList users={assignList} />
          <Divider style={{ margin: '0px 0px 10px 0px' }} />
        </>
      )}
      <Form
        form={form}
        layout="vertical"
        requiredMark={false}
        className={styles.assignToUsersForm}
        initialValues={{ userEmail: '' }}
        onFinish={addUsersToAssignList}
      >
        <Form.Item
          label={t('userEmail')}
          name="userEmail"
          rules={[{ required: true, message: t('fieldRequired') }]}
        >
          <Select
            placeholder="example@gmail.com"
            showSearch
            showArrow={false}
            autoFocus
            optionLabelProp="label"
            disabled={loading}
          >
            {users.map((item) => (
              <Option
                value={item.email}
                label={Utils.combineStrings([item.firstname, item.lastname]) ||item.email}
                key={item.id}
              >
                <UserItemMeta user={item} />
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item>
          <Row>
            <Col span={24} style={{ textAlign: 'right' }}>
              {assignList.length > 0 ? (
                <>
                  <Button type="link" htmlType="submit" disabled={loading}>
                    {t('addMoreUsers')}
                  </Button>
                  <Button
                    shape="round"
                    type="primary"
                    style={{ marginLeft: '8px' }}
                    loading={loading}
                    onClick={assignRoleToUsers}
                  >
                    {t('save')}
                  </Button>
                </>
              ) : (
                <Button shape="round" type="primary" htmlType="submit">
                  {t('addUsers')}
                </Button>
              )}
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </>
  );
};
